import { styles } from 'consts';
import styled from 'styled-components';

const { paymentColor, bluePrimary, fontMBank } = styles;

const setHeightMobile = ({ hasExtendedHeight }: { hasExtendedHeight: boolean }) =>
  hasExtendedHeight ? '15rem' : '13rem';
const setHeightDesktop = ({ hasExtendedHeight }: { hasExtendedHeight: boolean }) =>
  hasExtendedHeight ? '13rem' : '11rem';

interface ContainerProps {
  hasExtendedHeight: boolean;
}

export const Container = styled.div.attrs<ContainerProps>(({ hasExtendedHeight }) => ({
  hasExtendedHeight,
}))<ContainerProps>`
  width: 17.5rem;
  margin: 0.5rem auto 0.5rem;
  box-sizing: border-box;
  height: ${setHeightMobile};

  @media (min-width: 768px) {
    margin: 1.5rem auto;
    height: ${setHeightDesktop};
  }

  .label {
    display: inline-block;
    font-family: ${fontMBank};
    font-size: 0.615rem;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.6;
    letter-spacing: normal;
    color: #626262;
    text-align: left;
    float: none;
    width: 100%;
    max-width: 100%;
    padding: 0;
    position: static;
  }

  input {
    outline: none;
    height: 1.5rem;
    width: 100%;
    font-family: ${fontMBank};
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: 0.1625rem;
    line-height: 1.5rem;
    border: none;
    background: none;
    color: ${paymentColor};

    &:focus {
      caret-color: ${bluePrimary};
    }
  }

  #card-component__wl-main {
    padding: 1rem 1.5rem;
    border-radius: 12.1px;
    box-shadow: 0 23px 18px -20px rgba(0, 0, 0, 0.34);
    margin-top: 30px;
    background-color: #f5f5f7;
    height: 9rem;
  }

  .row {
    margin: 0.325rem 0 0.125rem 0;
  }

  .one-line {
    display: flex;
    justify-content: space-between;
  }

  .card-component__wl-input-expiration {
    width: 4rem;

    input {
      width: 4rem;
    }
  }

  .card-component__wl-input-cvc {
    width: 3rem;
    input {
      width: 3rem;
    }
  }

  .card-component__wl-show-saved-card {
    margin-top: 1.2rem;
  }
`;

export const ErrorContainer = styled.div`
  text-align: center;
  margin-top: 1.25rem;
  height: 1.25rem;
  font-family: ${fontMBank};
  font-size: 0.7rem;
  line-height: 1.25rem;
  color: red;
`;
